import { Button } from "antd";
import PropTypes from "prop-types";
import { DeleteOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

const Delete = ({
  loading = false,
  type = "danger",
  icon = <DeleteOutlined />,
  title = "button.delete",
  onClick = () => {},
  id = "btn-delete",
  ...props
}) => {
  const { t } = useTranslation();
  const translatedTitle = title === "button.delete" ? t(title) : title;
  props = { loading, icon, ...props };

  return (
    <Button
      danger={type === "danger"}
      type={type === "danger" ? "primary" : type}
      title={translatedTitle}
      onClick={onClick}
      id={id}
      {...props}
    >
      {translatedTitle}
    </Button>
  );
};

Delete.propTypes = {
  loading: PropTypes.bool,
  type: PropTypes.string,
  icon: PropTypes.node, // Ubah menjadi node agar bisa menerima string atau elemen React
  title: PropTypes.string,
  id: PropTypes.string,
  onClick: PropTypes.func,
};

export default Delete;
